/**
 * Data model for a user.
 */
export interface UserPrincipal {
    userName: string;
    domain: string;
    prinicipal: string;
    ssid: string;
}
